import {Component, Input, NgModule} from '@angular/core';

@Component({
  selector: 'sd-spinner, sd-progress-spinner',
  standalone: true,
  template: `
    <span
      class="inline-block animate-spin rounded-full border-2 border-neutral-200 border-t-[var(--m365-accent,#592c82)]"
      [style.width.px]="diameter"
      [style.height.px]="diameter"
      [style.border-width.px]="strokeWidth"
      role="progressbar"
      aria-label="Loading"
    ></span>
  `,
  host: {class: 'sd-spinner sd-progress-spinner inline-flex'},
})
export class SdProgressSpinner {
  @Input() diameter = 32;
  @Input() strokeWidth = 3;
  @Input() color: string | undefined;
  @Input() mode: 'determinate' | 'indeterminate' = 'indeterminate';
  @Input() value = 0;
}

export {SdProgressSpinner as SdSpinner};

@NgModule({
  imports: [SdProgressSpinner],
  exports: [SdProgressSpinner],
})
export class SdProgressSpinnerModule {}
